export enum ReasonForDeletion {
  NoLongerRequired = 'This organization is no longer required',
  CreatedByMistake = 'Organization was created by mistake',
  Restructuring = 'Hierarchy restructuring',
  ContractEnded = 'Contract has been ended',
  Other = 'Other',
}
